import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export const filterTruthy = () => <T>(source: Observable<T | null | undefined>) => source.pipe(
  filter(s => !!s),
  map<T | null | undefined, T>(s => s as T)
);
